import { useQuery } from '@apollo/client';
import { GET_ROOMTYPES } from '../gql/gql-rooms';

export type UseHookArgs = {
  brandCode: string;
  snapshotDate: string;
  callback: () => void;
  endDate?: string;
  startDate?: string;
  useCache?: boolean;
};

export function useRooms(a: UseHookArgs) {
  const { brandCode, endDate, snapshotDate, startDate, callback, useCache } = a;
  return useQuery(GET_ROOMTYPES, {
    variables: {
      brandCode,
      endDate,
      snapshotDate,
      startDate,
      useCache,
    },
    skip: !brandCode || !snapshotDate,
    onCompleted: () => callback(),
  });
}
